// « À corriger » = items à problème de CONTENU (Approche 1 / Lot QA-2).
// Le signal de tête et la section « À corriger » partagent CETTE définition.
//
// Sont retenus : item halluciné (flag `hallucinated` du juge), citation non
// ancrée au transcript (`notAnchored`), ou résumé non ancré sur les nombres
// (`summaryFactualWarning`). Les **retypages purs** sont EXCLUS : le type
// n'affecte quasiment pas la synthèse (taxonomie = biais doux), donc une
// reclassification ne mérite pas l'alarme — elle reste corrigeable par item.

interface CorrectableItem {
  id: string;
  needsReview: boolean;
  notAnchored: boolean;
  summaryFactualWarning: boolean;
}

interface AuditLike {
  flags: { hallucinated: { item_id?: string | null }[] };
}

export function itemsToCorrect<T extends CorrectableItem>(
  items: readonly T[],
  audit: AuditLike | null,
): T[] {
  const hallucinated = new Set(
    (audit?.flags.hallucinated ?? [])
      .map((f) => f.item_id)
      .filter((id): id is string => id != null),
  );
  // Un item halluciné n'est « à corriger » que tant qu'il n'est PAS résolu
  // (`needsReview`) : appliquer la correction / valider efface `needsReview` →
  // l'item quitte la liste (le flag d'audit `hallucinated`, lui, est figé).
  return items.filter(
    (i) => i.notAnchored || i.summaryFactualWarning || (i.needsReview && hallucinated.has(i.id)),
  );
}

export function countToCorrect<T extends CorrectableItem>(
  items: readonly T[],
  audit: AuditLike | null,
): number {
  return itemsToCorrect(items, audit).length;
}
